/**
 * LiveBadge — small pill that labels a view as running against live data
 * or the mock fixtures. Extracted from inline duplicates in
 * TurnoutHeatmapView and DropOffView so the two views share one visual.
 *
 * Colors route through semantic tokens so light/dark modes track the
 * rest of the dashboard.
 *
 *   <LiveBadge />                            // "Live" pill
 *   <LiveBadge mock />                       // "Mock" pill
 *   <LiveBadge mock title="Custom hint" />   // override the tooltip
 */
import React from 'react';

type Props = {
  mock?: boolean;
  /** Override the default hover tooltip. */
  title?: string;
};

const LIVE_TITLE = 'Live data from the backend.';
const MOCK_TITLE = 'Mock data — flip VITE_USE_MOCK_ANALYTICS=0 to query Postgres.';

export function LiveBadge({ mock, title }: Props) {
  if (mock) {
    return (
      <span
        className="inline-flex items-center gap-1 rounded bg-status-warning-bg/15 text-status-warning border border-status-warning-bg/30 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
        title={title ?? MOCK_TITLE}
      >
        <span
          aria-hidden="true"
          className="inline-block h-1.5 w-1.5 rounded-full bg-status-warning"
        />
        Mock
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1 rounded bg-status-success-bg/15 text-status-success border border-status-success-bg/30 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
      title={title ?? LIVE_TITLE}
    >
      <span
        aria-hidden="true"
        className="inline-block h-1.5 w-1.5 rounded-full bg-status-success"
      />
      Live
    </span>
  );
}

export default LiveBadge;
